const themeLightBackgroundBase = '#FFF';

export { themeLightBackgroundBase };
